import React from 'react';

import { Select } from 'antd/es';
import { Field } from 'formik';

import '@app/scss/localCommon/components/customAutoTokenization.scss';

const { Option } = Select;

const CustomAutoTokenization = ({ name, placeholder, onChange }) => {
	return (
		<Field
			name={name}
		>
			{(field) => {
				return (
					<div
						className={
							field.form.errors[name] && field.form.touched[name]
								? 'custom-field custom-input custom-tokenization error'
								: 'custom-field custom-input custom-tokenization'
						}
					>
						<Select
							classNames={{ popup: { root: 'custom-tokenization__dropdown' } }}
							mode="tags"
							tokenSeparators={[',', ' ', ';']}
							placeholder={placeholder}
							open={false}
							onChange={onChange}
							onBlur={() => field.form.setFieldTouched(name, true)}
						/>
						{field.form.errors[name] ? (
							<div className="custom-input__error">
								{field.form.errors[name].find((item) => item)}
							</div>
						) : null}
					</div>
				);
			}}
		</Field>
	);
};

export default CustomAutoTokenization;
